import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/new_ui/Modal/Modal';

import { Button } from 'react-bootstrap5';

import { useContext } from './Context';

export default function VideoDescriptionPopup({ show, onStart, onClose }) {
  const [openVideo, setOpenVideo] = useState(false);
  const [checked, setChecked] = useState(false);

  const { dispatch, actions } = useContext();

  const skipPopup = () => {
    actions.skipAiSessionDescriptionPopup(dispatch);
  };

  const onSkipClick = () => {
    setOpenVideo(false);
    if (checked) {
      skipPopup();
    }
    onClose();
  };

  const onStartClick = () => {
    setOpenVideo(true);
    if (checked) {
      skipPopup();
    }
    onClose();
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onClose}
      onExited={() => {
        if (openVideo) {
          setTimeout(() => {
            onStart();
          }, 1000);
        }
      }}
      header={<h2 className="ms-3">AI Coach Session</h2>}
    >

      <h3>What to Expect</h3>
      <p>
        Our AI Coach uses advanced conversational intelligence to provide
        personalized guidance while maintaining complete confidentiality.
        Come prepared to discuss your goals, challenges, and any specific
        topics you&apos;d like to address during our session.
      </p>

      <div>
        <label htmlFor="do-not-show-ai-video-description">
          <input
            onChange={() => setChecked((prev) => !prev)}
            id="do-not-show-ai-video-description"
            className="boolean optional form-check-input me-2"
            type="checkbox"
            checked={checked}
          />
          Do not show this popup again
        </label>
      </div>

      <footer className="d-flex justify-content-end">
        <Button onClick={onStartClick}>
          Start Now
        </Button>
      </footer>
    </Modal>
  );
}

VideoDescriptionPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  onStart: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
